//@actions
export const actions = {
  changeResource(store: any, resource: string) {
    store.commit('updateResource', resource)
  },
  changeResourceId(store: any, resource_id: string) {
    store.commit('updateResourceId', resource_id);
  },
}

